import { useLocale } from '@issuemanager/apps/client/hooks';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import 'dayjs/locale/en';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';
import 'dayjs/locale/ja';
import 'dayjs/locale/nl';
import 'dayjs/locale/pt';
import 'dayjs/locale/zh';
import { PropsWithChildren, useEffect, type JSX } from 'react';

export default function DateTimeLocalizationContainer({
  children,
}: PropsWithChildren): JSX.Element {
  const locale = useLocale();

  useEffect(() => {
    // set dayjs locale globally
    dayjs.locale(locale);
  }, [locale]);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      {children}
    </LocalizationProvider>
  );
}
